import * as R from 'ramda';
import { createSelector } from 'reselect';
// helpers/constants
import * as GC from '../../constants';
// report-common
import { getReportSelectors } from '../../report-common';
//////////////////////////////////////////////////

const {
  store,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
} = getReportSelectors('equipmentServiceInvoice');

const makeSelectBranchConfigs = createSelector(
  store,
  ({ branchConfigs }) => branchConfigs,
);

const makeSelectItemList = createSelector(
  store,
  R.compose(R.sortBy(R.prop('index')), R.values, R.prop('itemList')),
);

const makeSelectSelectedItemListGuids = createSelector(
  store,
  R.compose(
    R.values,
    R.map(R.prop(GC.FIELD_GUID)),
    R.filter(R.prop('selected')),
    R.propOr([], 'itemList'),
  ),
);

export {
  makeSelectItemList,
  makeSelectUsedReport,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectListLoading,
  makeSelectPageVisited,
  makeSelectReportStatus,
  makeSelectBranchConfigs,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
  makeSelectSelectedItemListGuids,
};
